module.exports = __webpack_public_path__ + "img/zoho_icon.b044859d.svg";